import { useHistory } from "react-router-dom";
import { Form, Input, message, Button, Select } from "antd";
import { updateOne } from "../../../api/bdPosibleParticipante";
import { formLayout } from "../../../utils/constants";

const { Option } = Select;

function EditRecord({ record, closeModal, setModalContent }) {
  const history = useHistory();

  const onFinish = (values) => {
    sendDataToServer(values);
  };

  // ------ Actualiza usuario ------
  const sendDataToServer = async (data) => {
    try {
      const response = await updateOne(data, record._id);
      message.success(response.message);
      history.replace("/app/bdparticipante");
      closeModal();
    } catch (err) {
      message.error(err.message);
    }
  };

  const onFinishFailed = ({ values }) => {
    if (Number(values.nrodocumento) < 1) {
      message.error("Número de DNI no válido");
    }
  };

  return (
    <Form
      {...formLayout.formItemLayout}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="Número de DNI"
        name="nrodocumento"
        initialValue={record.nrodocumento}
        rules={[
          {
            required: true,
            message: "El campo DNI es necesario"
          },
          {
            len: 8,
            message: "El valor debe tener 8 caracteres"
          }
        ]}
      >
        <Input type="number" />
      </Form.Item>

      <Form.Item
        label="Nombres"
        name="nombre"
        initialValue={record.nombre}
        rules={[{ required: true, message: "El nombre es necesario" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Apellidos"
        name="apellido"
        initialValue={record.apellido}
        rules={[{ required: true, message: "El apellido es necesario" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Correo electrónico"
        name="email"
        initialValue={record.email}
        rules={[{ required: true, message: "El email es necesario" }]}
      >
        <Input type="email" />
      </Form.Item>

      <Form.Item label="Celular" initialValue={record.nrocelular} name="nrocelular">
        <Input />
      </Form.Item>

      <Form.Item
        label="Elige el tipo"
        name="tipoorigen"
        rules={[{ required: true, message: "El origen es necesario" }]}
        initialValue={record.tipoorigen}
      >
        <Select>
          <Option value="estudiante">ESTUDIANTE</Option>
          <Option value="docente">DOCENTE</Option>
          <Option value="administrativo">ADMINISTRATIVO</Option>
        </Select>
      </Form.Item>

      <div className="flex justify-end gap-4">
        <Form.Item {...formLayout.tailFormItemLayout}>
          <Button type="primary" block htmlType="submit">
            Actualizar posible participante
          </Button>
        </Form.Item>
        <Button type="default" onClick={() => closeModal()}>
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default EditRecord;
